import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";

const DashboardContext = createContext();

export const useDashboard = () => useContext(DashboardContext);

export const DashboardProvider = ({ children }) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const accessToken = sessionStorage.getItem("accessToken");
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || "";
  

  const [dashboardData, setDashboardData] = useState([]);
  const [shouldRefetch, setShouldRefetch] = useState(false);

  // Only fetch dashboard data if userDetails is available
  useEffect(() => {  
    if (!userDetails) return;

    const headers = accessToken
        ? {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
        }
        : { "Content-Type": "application/json" };

    const fetchDashboardPages = async () => {
      try {
        const response = await axios.get(`${baseUrl}/user/${userDetails?.id}/getAllDashboardPages`, { headers });
        setDashboardData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching dashboard pages:", error);
      }
    };

    if (shouldRefetch) {
      fetchDashboardPages(); // Re-fetch the data
      setShouldRefetch(false); // Reset the refetch flag
    } else {
      fetchDashboardPages(); // Initial fetch
    }
  }, [shouldRefetch]); // Add userDetails as a dependency

  return (
    <DashboardContext.Provider value={{ dashboardData, setDashboardData, setShouldRefetch }}>
      {children}
    </DashboardContext.Provider>
  );
};